module.exports = __webpack_public_path__ + "img/logo1.1fbf1b86.png";